import { BucketDef } from './bucket-def';
import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';

export class ALMShortTermBucketing extends BaseBucketingStrategy implements BucketingStrategy {
    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs(): void {
        this.bucketDefs.push(new BucketDef(this.today, this.startOfNextBucket(), false, 'Today'));
        for (let i = 1; i <= 7; i++) {
            this.bucketDefs.push(new BucketDef(this.today.clone().add(i, 'days'), this.startOfNextBucket(), false, `${i}D`));
        }
        this.bucketDefs.push(new BucketDef(this.today.clone().add(2, 'week'), this.startOfNextBucket(), true, '2W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(3, 'week'), this.startOfNextBucket(), true, '3W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(4, 'week'), this.startOfNextBucket(), true, '4W'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 2, true), this.startOfNextBucket(), true, '2M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 3, true), this.startOfNextBucket(), true, '3M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 4, true), this.startOfNextBucket(), true, '4M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 5, true), this.startOfNextBucket(), true, '5M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
    }

    strategyName(): string {
        return 'ALMShortTerm';
    }
}

